import keyMirror from 'keymirror';

/**
 * @constant {Object} ApplicationConstants
 * @memberof Application
 */
export const WorkflowConstants = keyMirror({
  CHECKIN_ACTION: undefined,
  NEXT_ACTION: undefined,
  PREVIOUS_ACTION: undefined,
  GET_IP_ADDRESS: undefined,
  SEND_CONTRACT_TO_CONSUMER: undefined,
  UPDATE_OFFER: undefined,
});
